import { Injectable } from '@angular/core';
import { HttpApiService } from '../base/http-api.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../entities/api-response.model';
import { EnzymesModel } from '../../entities/enzimes.model';

@Injectable({
  providedIn: 'root'
})
export class EnzymesService {

    constructor(
        public httpApiService: HttpApiService,
    ) {

    }

    public get(uid): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('enzymes/view', {uid});
    }

    public getList(): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('enzymes/view-list');
    }

    public set(enzyme: EnzymesModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('enzymes/store', enzyme);
    }

    public delete(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpDelete('enzymes/destroy', { uid });
    }
}
